<template>
    <div class="main-page">
        <Banner/>
        <Guarantees/>
        <Banks/>
        <Accreditation />
        <BecomeAnAgent/>
    </div>
</template>

<script>
import Banner from "@/components/main/Banner"
import Guarantees from "@/components/main/Guarantees"
import BecomeAnAgent from "@/components/main/BecomeAnAgent"
import Banks from "@/components/main/Banks"
import Accreditation from "@/components/main/Accreditation"

export default {
    name: 'Home',
    components: {
        BecomeAnAgent,
        Guarantees,
        Banner,
        Banks,
        Accreditation
    }
}
</script>
